import { useState } from "react";
import { saveAccountCode } from "../Api/AccountCodeMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const AccountCodeMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const [accountCodeData, setAccountCodeData] = useState({
    accountCode: "",
    accountName: "",
    accountHead: "",
    status: "Active", 
  });

  const handleChange = (e) => {
    setAccountCodeData({ ...accountCodeData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveAccountCode(accountCodeData, userId); 
      toast.success(`🦄 Account Code Added Successfully`);
      setAccountCodeData({
        accountCode: "",
        accountName: "",
        accountHead: "",
        status: "Active",
      });
      navigate("/accountCodeMaster");
    } catch (error) {
      toast.error(`🦄 Error saving account code: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Account Code Master</h2>

          {loading && (
            <div className="loading-overlay">
              <Sample14 />
            </div>
          )}

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Account Code <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="accountCode"
                    value={accountCodeData.accountCode}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Account Name <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="accountName"
                    value={accountCodeData.accountName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Account Head <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="accountHead"
                    value={accountCodeData.accountHead}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Account Status <span className="text-red">**</span></Form.Label>
                  <Form.Select
                    name="status"
                    value={accountCodeData.status}
                    onChange={handleChange}
                    required
                  >
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button
                variant="primary"
                type="submit"
                className="fields-submit"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Account Code"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
  );
};

export default AccountCodeMaster;